import React from 'react';
import ChevronRight from '@uber/base-icons/chevron-right';
import { useStyletron } from 'baseui';
import { ListItem } from 'baseui/list';
import { Tag, TagKind } from 'baseui/tag';
import { LabelLarge, LabelMedium } from 'baseui/typography';
const tagOverrides = {
  Root: {
    style: {
      margin: '0',
      cursor: 'inherit'
    }
  }
};
export const STATUS_TYPE = ({
  PENDING: 'PENDING',
  DONE: 'DONE',
  OPTIONAL: 'OPTIONAL',
  WARNING: 'WARNING'
} as const);
export const STATUS_TEXT = ({
  [STATUS_TYPE.PENDING]: 'Pending',
  [STATUS_TYPE.DONE]: 'Done',
  [STATUS_TYPE.OPTIONAL]: 'Optional',
  [STATUS_TYPE.WARNING]: 'Warning'
} as const);
export const ActionHeader = ({
  title,
  status,
  onActionClick,
  statusText,
  titleTypography = 'large'
}: {
  title: string;
  status?: (typeof STATUS_TYPE)[keyof typeof STATUS_TYPE];
  onActionClick: () => void;
  statusText?: string;
  titleTypography?: 'small' | 'large';
}) => {
  const [css, theme] = useStyletron();
  const TitleTypography = titleTypography === 'small' ? LabelMedium : LabelLarge;
  return <ListItem endEnhancer={() => <ChevronRight size={18} color={theme.colors.contentPrimary} />} onClick={onActionClick} overrides={{
    Root: {
      style: ({
        $theme
      }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: $theme.sizing.scale400,
        justifyContent: 'space-between',
        width: '100%',
        padding: `${$theme.sizing.scale700} 0`,
        borderTop: `1px solid ${$theme.colors.borderTransparent}`
      })
    },
    Content: {
      style: {
        borderBottom: 'none',
        padding: '0',
        margin: '0',
        minHeight: 'auto'
      }
    }
  }}>
      <div className={css({
      display: 'flex',
      alignItems: 'center',
      gap: theme.sizing.scale500
    })}>
        <TitleTypography margin={0} color={theme.colors.contentPrimary}>
          {title}
        </TitleTypography>
        {status === STATUS_TYPE.PENDING && <Tag closeable={false} kind={TagKind.accent} overrides={tagOverrides}>
            {statusText || STATUS_TEXT[STATUS_TYPE.PENDING]}
          </Tag>}
        {status === STATUS_TYPE.OPTIONAL && <Tag closeable={false} kind={TagKind.neutral} overrides={tagOverrides}>
            {statusText || STATUS_TEXT[STATUS_TYPE.OPTIONAL]}
          </Tag>}
        {status === STATUS_TYPE.DONE && <Tag closeable={false} kind={TagKind.positive} overrides={tagOverrides}>
            {statusText || STATUS_TEXT[STATUS_TYPE.DONE]}
          </Tag>}
        {status === STATUS_TYPE.WARNING && <Tag closeable={false} kind={TagKind.warning} overrides={tagOverrides}>
            {statusText || STATUS_TEXT[STATUS_TYPE.WARNING]}
          </Tag>}
      </div>
    </ListItem>;
};